import React, { useEffect, useState } from 'react';
import { Download, Check } from 'lucide-react';

// Shows an "Install app" button when the browser offers PWA installation.
// Tapping it triggers the native install prompt → creates a desktop/home-screen shortcut.
export default function InstallButton({ collapsed = false }) {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(
    () => window.matchMedia && window.matchMedia('(display-mode: standalone)').matches
  );

  useEffect(() => {
    const onBeforeInstall = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => { setInstalled(true); setPrompt(null); };
    window.addEventListener('beforeinstallprompt', onBeforeInstall);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstall);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const install = async () => {
    if (!prompt) return;
    prompt.prompt();
    try { await prompt.userChoice; } catch (e) { /* ignore */ }
    setPrompt(null);
  };

  if (installed) {
    if (collapsed) {
      return (
        <div className="flex justify-center mb-3" title="App installed" data-testid="app-installed-badge">
          <Check size={16} style={{ color: 'var(--kmt-green)' }} />
        </div>
      );
    }
    return (
      <div className="flex items-center gap-2 justify-center text-xs mb-3" style={{ color: 'var(--kmt-green)' }} data-testid="app-installed-badge">
        <Check size={14} /> App installed
      </div>
    );
  }

  if (!prompt) return null;

  if (collapsed) {
    return (
      <button onClick={install} title="Install app" data-testid="install-app-btn"
        className="w-9 h-9 mx-auto mb-3 rounded-md flex items-center justify-center kmt-panel-2 hover:bg-[#2a2a30]" style={{ color: 'var(--kmt-gold)' }}>
        <Download size={16} />
      </button>
    );
  }

  return (
    <button onClick={install} data-testid="install-app-btn"
      className="w-full mb-3 flex items-center justify-center gap-2 rounded-lg py-2 text-sm font-medium transition-colors"
      style={{ background: 'rgba(212,175,55,0.12)', border: '1px solid var(--kmt-gold-dim)', color: 'var(--kmt-gold)' }}>
      <Download size={15} /> Install app
    </button>
  );
}
